import type { InviteRecipientResponse } from "@repo/shared/types";
import { get } from "../_client";

const BASE = "/internal/flow-instances";

/**
 * QL-505 follow-up — who the Invite Client dialog sends to: the client
 * themself, their representative only (a warning is shown before sending),
 * or "members" for a group without a representative (per-member rows
 * instead of a single send target).
 */
export function getInviteRecipient(instanceId: string) {
  return get<InviteRecipientResponse>(`${BASE}/${instanceId}/invite-recipient`);
}
